module.exports = __webpack_public_path__ + "static/media/payment-failure.9570be21.png";